export default () => ({
    news: {},
    loading: false,
    error: false,
    news_categories:[],
    keyed_news_categories:{},
    place_categories:[],
    keyed_place_categories:{}
});
